import { useEditorContext } from "../EditorContext";
import FormLabel from "../FormCommonField/FormLabel";
import { getBorderStyleObj } from "../FormText/FormBaseStyle";
import { getFontFamily, toRGBA } from "../parser/utils";

export default ({ data }) => {
  const {
    id,
    rows,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    optionsDefaultFont,
    optionsFontSize,
    optionsFontColor,
    labelFontColor,
    labelDefaultFont,
    labelFontSize,
    labelHorizonAlignment,
  } = data;

  const { state } = useEditorContext();
  const { formBorderWidth, formBorderStyle, formBorderColor, formTextColor } =
    state.root.data;
  const borderStyleObj = getBorderStyleObj(state.root.data);
  const customLabelStyle = {
    color: toRGBA(labelFontColor || formTextColor),
    fontFamily: labelDefaultFont,
    fontSize: labelFontSize,
    justifyContent: labelHorizonAlignment,
  };

  const optionFontFamily = getFontFamily(
    optionsDefaultFont,
    state.root.data.defultFont
  );

  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "left",
      }}
    >
      <FormLabel data={data} customLabelStyle={customLabelStyle} />
      <div style={borderStyleObj}>
        <table width={"100%"} style={{ textAlign: "left" }}>
          <tr
            style={{
              height: "35px",
              color: toRGBA(formTextColor),
              fontFamily: optionFontFamily,
              fontSize: `${optionsFontSize}px`, // 应用字体大小
            }}
          >
            <th></th>
            {data.cols.map((col, index) => (
              <th
                style={{ color: toRGBA(optionsFontColor || formTextColor) }}
                key={index}
              >
                {col.value}
              </th>
            ))}
          </tr>
          <tbody>
            {rows.map((item, index) => {
              return (
                <tr
                  key={index}
                  style={{
                    color: toRGBA(labelFontColor || formTextColor),
                    height: "35px",
                    borderTop: [
                      formBorderWidth + "px",
                      formBorderStyle,
                      toRGBA(formBorderColor),
                    ].join(" "),
                  }}
                >
                  <td
                    style={{
                      color: toRGBA(optionsFontColor || formTextColor),
                      fontFamily: optionFontFamily,
                      fontSize: `${optionsFontSize}px`, // 应用字体大小
                      padding: "0 8px",
                      marginBottom: 0,
                      fontWeight: "normal",
                    }}
                  >
                    {item.label}
                  </td>
                  {data.cols.map((value) => {
                    return (
                      <td
                        key={value}
                        style={{
                          color: toRGBA(optionsFontColor || formTextColor),
                          padding: "0 8px",
                        }}
                      >
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            border: "1px solid #cccccc",
                          }}
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
